import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
  tone?: 'graphite' | 'light';
}
export function CtaButton({
  children,
  href = '#offre',
  className = '',
  size = 'lg',
  tone = 'graphite'
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base md:text-lg' : 'px-6 py-3 text-sm md:text-base';
  const toneClasses = tone === 'graphite' ? 'focus-visible:outline-accent' : 'focus-visible:outline-creme';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-accent font-semibold text-white transition-colors duration-150 ease-out hover:bg-accent-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${sizeClasses} ${toneClasses} ${className}`} data-id="element-86" data-mp="10a3q008296uz">
      <span data-id="element-87" data-mp="15ahs71mzdml3">{children}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true" data-id="element-88" data-mp="15bavttqn7vz0" />
    </a>;
}